module.exports = __webpack_public_path__ + "static/media/bg.7f73837d.png";